module.exports = __webpack_public_path__ + "img/individual_weddingrings.2f9b8c6.webp";